/**
 * Valida que una URL tenga protocolo http o https.
 * Previene open redirects y javascript: / data: URLs maliciosas.
 */
export function esUrlSegura(url) {
  if (!url || typeof url !== 'string') return false;
  try {
    const parsed = new URL(url.trim());
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Devuelve la URL si es segura, o null si no lo es.
 * Útil en render: <a href={urlSeguraONull(p.sitioWeb)}>
 */
export function urlSeguraONull(url) {
  return esUrlSegura(url) ? url.trim() : null;
}
